import React from "react";
import {WithTranslation, withTranslation} from "react-i18next";
import {autoFormatDate, DATE_FORMAT_WITH_TIME} from "../../../../services/UtilsService";
import ValidationItem from "../ValidationItem";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    date: Date
}

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 04/07/2022
 * @last_update 04/07/2022
 **/
class OperationDate extends React.Component<Props> {

    render() {

        /**
* Retrieves from the props the function to access the translation.
**/
const getTranslation = this.props.t;

        return (

            <ValidationItem label={getTranslation("steps.validation.labels.date")}>
                {autoFormatDate(this.props.date, DATE_FORMAT_WITH_TIME)}
            </ValidationItem>

        );

    };

}

export default withTranslation()(OperationDate);
